import { LoadingStatus, Status } from '@bcef/ia-shared';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromConfig from '../../reducers/config/config.reducer';

export const selectConfigState = createFeatureSelector<fromConfig.ConfigState>(
  fromConfig.configFeature.name,
);

export const selectConfiguration = createSelector(
  selectConfigState,
  (state: fromConfig.ConfigState) => state.config,
);

export const selectConfigStatus = createSelector(
  selectConfigState,
  (state: fromConfig.ConfigState) => state.configLoadingStatus,
);

export const selectConfigLoadStatus = createSelector(
  selectConfigStatus,
  (loadingStatus: LoadingStatus) => {
    let status = Status.INITIAL;
    if (loadingStatus.isLoaded) {
      status = Status.SUCCESS;
    } else if (!!loadingStatus.error) {
      status = Status.FAIL;
    }
    return status;
  },
);
